var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_97250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.853554 8.92379C0.658292 9.11905 0.341709 9.11905 0.146447 8.92379C-0.0488151 8.72853 -0.0488153 8.41195 0.146447 8.21668L3.32805 5.03508L0.146521 1.85355C-0.0487414 1.65829 -0.0487414 1.34171 0.146521 1.14645C0.341783 0.951184 0.658365 0.951184 0.853627 1.14645L4.3722 4.66502C4.37793 4.67024 4.38355 4.67562 4.38909 4.68115C4.47538 4.76745 4.52354 4.87744 4.53356 4.99018C4.54647 5.1328 4.49834 5.27991 4.38916 5.38909C4.38311 5.39514 4.37694 5.401 4.37066 5.40668L0.853554 8.92379Z",
    fill: "#5E5E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_97250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    fill: "white",
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b8b9ca70.svg";
export { ForwardRef as ReactComponent };